export default "__VITE_ASSET__BcEwV8rZ__"